export default {
  map(state) {
    return state.map;
  },
};
